module.exports = __webpack_public_path__ + "static/img/m_role.1277c8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/kr/m_role.png
// module id = IGgu
// module chunks = 7